import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  id: "showServiceModal"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "d-flex align-items-center flex-grow-1 gap-2" }
const _hoisted_6 = { class: "text-sm fw-semibold" }
const _hoisted_7 = { class: "ms-auto text-sm text-muted" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { style: {"height":"300px"} }
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = { class: "timeline-section__title text-sm mb-3" }
const _hoisted_12 = { class: "service-timeline" }
const _hoisted_13 = { class: "service-timeline__track" }
const _hoisted_14 = {
  key: 0,
  class: "tl-duration"
}
const _hoisted_15 = { class: "service-timeline__labels" }
const _hoisted_16 = { class: "tl-label" }
const _hoisted_17 = { class: "text-xs fw-semibold" }
const _hoisted_18 = {
  key: 0,
  class: "text-xs text-muted"
}
const _hoisted_19 = {
  key: 0,
  class: "tl-label-gap"
}
const _hoisted_20 = { class: "row mt-4" }
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = { class: "service-info-card" }
const _hoisted_23 = { class: "service-info-card__title" }
const _hoisted_24 = { class: "gorda-info-row" }
const _hoisted_25 = { class: "gorda-info-row__key" }
const _hoisted_26 = { class: "gorda-info-row__value" }
const _hoisted_27 = {
  key: 0,
  class: "gorda-info-row"
}
const _hoisted_28 = { class: "gorda-info-row__key" }
const _hoisted_29 = { class: "gorda-info-row__value" }
const _hoisted_30 = { class: "gorda-info-row" }
const _hoisted_31 = { class: "gorda-info-row__key" }
const _hoisted_32 = { class: "gorda-info-row__value" }
const _hoisted_33 = { class: "gorda-info-row" }
const _hoisted_34 = { class: "gorda-info-row__key" }
const _hoisted_35 = { class: "gorda-info-row__value" }
const _hoisted_36 = { class: "gorda-info-row" }
const _hoisted_37 = { class: "gorda-info-row__key" }
const _hoisted_38 = { class: "gorda-info-row__value" }
const _hoisted_39 = { class: "gorda-info-row" }
const _hoisted_40 = { class: "gorda-info-row__key" }
const _hoisted_41 = { class: "gorda-info-row__value" }
const _hoisted_42 = { class: "gorda-info-row" }
const _hoisted_43 = { class: "gorda-info-row__key" }
const _hoisted_44 = { class: "gorda-info-row__value" }
const _hoisted_45 = { class: "gorda-info-row" }
const _hoisted_46 = { class: "gorda-info-row__key" }
const _hoisted_47 = { class: "gorda-info-row__value" }
const _hoisted_48 = { class: "gorda-info-row" }
const _hoisted_49 = { class: "gorda-info-row__key" }
const _hoisted_50 = { class: "gorda-info-row__value" }
const _hoisted_51 = {
  key: 1,
  class: "gorda-info-row"
}
const _hoisted_52 = { class: "gorda-info-row__key" }
const _hoisted_53 = { class: "gorda-info-row__value" }
const _hoisted_54 = {
  key: 2,
  class: "gorda-info-row"
}
const _hoisted_55 = { class: "gorda-info-row__key" }
const _hoisted_56 = { class: "gorda-info-row__value" }
const _hoisted_57 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_58 = { class: "service-info-card__title" }
const _hoisted_59 = { class: "gorda-info-row" }
const _hoisted_60 = { class: "gorda-info-row__key" }
const _hoisted_61 = { class: "gorda-info-row__value" }
const _hoisted_62 = { class: "col-6" }
const _hoisted_63 = {
  key: 0,
  class: "service-info-card"
}
const _hoisted_64 = { class: "service-info-card__title" }
const _hoisted_65 = { class: "gorda-info-row" }
const _hoisted_66 = { class: "gorda-info-row__key" }
const _hoisted_67 = { class: "gorda-info-row__value" }
const _hoisted_68 = { class: "gorda-info-row" }
const _hoisted_69 = { class: "gorda-info-row__key" }
const _hoisted_70 = { class: "gorda-info-row__value" }
const _hoisted_71 = { class: "gorda-info-row" }
const _hoisted_72 = { class: "gorda-info-row__key" }
const _hoisted_73 = { class: "gorda-info-row__value" }
const _hoisted_74 = { class: "gorda-info-row" }
const _hoisted_75 = { class: "gorda-info-row__key" }
const _hoisted_76 = { class: "gorda-info-row__value" }
const _hoisted_77 = { class: "gorda-info-row" }
const _hoisted_78 = { class: "gorda-info-row__key" }
const _hoisted_79 = { class: "gorda-info-row__value" }
const _hoisted_80 = { class: "gorda-info-row" }
const _hoisted_81 = { class: "gorda-info-row__key" }
const _hoisted_82 = { class: "gorda-info-row__value" }
const _hoisted_83 = { class: "gorda-info-row" }
const _hoisted_84 = { class: "gorda-info-row__key" }
const _hoisted_85 = { class: "gorda-info-row__value" }
const _hoisted_86 = {
  key: 0,
  class: "gorda-info-row"
}
const _hoisted_87 = { class: "gorda-info-row__key" }
const _hoisted_88 = { class: "gorda-info-row__value" }
const _hoisted_89 = { class: "modal-footer" }
const _hoisted_90 = {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}

import { PlaceInterface } from '@/types/PlaceInterface'
import { computed, onMounted, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Map from '@/components/maps/Map.vue'
import ClientCompletedBadge from '@/components/services/ClientCompletedBadge.vue'
import { ServiceList } from '@/models/ServiceList'
import Service from '@/models/Service'
import DateHelper from '@/helpers/DateHelper'
import ServiceHelper from '@/helpers/ServiceHelper'
import AuthService from '@/services/AuthService'
import { useSettingsStore } from '@/services/stores/SettingsStore'
import { useWpClientsStore } from '@/services/stores/WpClientStore'
import { useDriversStore } from '@/services/stores/DriversStore'

interface Props {
  service: ServiceList
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowServiceModal',
  props: {
    service: {}
  },
  setup(__props: any) {

const props = __props
const { t } = useI18n()
const location = reactive<Array<PlaceInterface>>([])
const { branchSelected } = useSettingsStore()
const wpClientsStore = useWpClientsStore()
const driversStore = useDriversStore()

const startLocName = computed(() => {
  const name = props.service.start_loc.name
  return ServiceHelper.isSelfServiceStartLoc(name) ? t('services.self_service_trip') : name
})

const createdBy = ref<string>('Sistema')
const canceledBy = ref<string>('Sistema')
const terminatedBy = ref<string>('Sistema')
const assignedBy = ref<string>('Sistema')

onMounted(async () => {
  location.push({
    id: props.service.id,
    key: props.service.id,
    name: startLocName.value,
    lat: props.service.start_loc.lat,
    lng: props.service.start_loc.lng
  })
  if (props.service.end_loc) {
    location.push({
      id: `${props.service.id}-end`,
      key: `${props.service.id}-end`,
      name: props.service.end_loc.name,
      lat: props.service.end_loc.lat,
      lng: props.service.end_loc.lng
    })
  }

  await loadUserData()
})

const loadUserData = async () => {
  if (props.service.created_by) {
    const user = await props.service.getCreatedBy()
    createdBy.value = user?.name || 'Sistema'
  }

  if (props.service.canceled_by) {
    const user = await props.service.getCanceledBy()
    canceledBy.value = user?.name || 'Sistema'
  }

  if (props.service.terminated_by) {
    const user = await props.service.getTerminatedBy()
    terminatedBy.value = user?.name || 'Sistema'
  }

  if (props.service.assigned_by) {
    const user = await props.service.getAssignedBy()
    assignedBy.value = user?.name || 'Sistema'
  }
}

const origin = computed(() => {
  const explicit = props.service.origin
  const kind = explicit === Service.ORIGIN_TEST ? 'test'
    : explicit === Service.ORIGIN_DRIVER ? 'driver'
    : explicit === 'admin' ? 'admin'
    : explicit === 'bot' ? 'bot'
    : props.service.created_by ? 'admin'
    : props.service.wp_client_id ? 'bot'
    : 'unknown'
  if (kind === 'test') {
    return { kind: 'test' as const, label: t('services.origin.test'), sublabel: null }
  }
  if (kind === 'driver') {
    return { kind: 'driver' as const, label: t('services.origin.driver'), sublabel: props.service.driver?.name ?? null }
  }
  if (kind === 'admin') {
    return { kind: 'admin' as const, label: t('services.origin.admin'), sublabel: createdBy.value || null }
  }
  if (kind === 'bot') {
    const alias = wpClientsStore.getWpClient(props.service.wp_client_id)?.alias ?? null
    return { kind: 'bot' as const, label: t('services.origin.bot'), sublabel: alias }
  }
  return { kind: 'unknown' as const, label: t('services.origin.unknown'), sublabel: null }
})

const originIcon = computed(() => {
  if (origin.value.kind === 'test') return 'fa-flask'
  if (origin.value.kind === 'bot') return 'fa-tower-broadcast'
  if (origin.value.kind === 'admin') return 'fa-toolbox'
  if (origin.value.kind === 'driver') return 'fa-mobile-screen'
  return 'fa-question'
})

const targetDriverName = computed(() => {
  if (!props.service.directed_to) return null
  return driversStore.findById(props.service.directed_to)?.name ?? props.service.directed_to
})

const statusBadgeClass = computed(() => {
  switch (props.service.status) {
    case Service.STATUS_TERMINATED: return 'success'
    case Service.STATUS_CANCELED: return 'danger'
    case Service.STATUS_IN_PROGRESS: return 'info'
    case Service.STATUS_PENDING: return 'warning'
    default: return 'secondary'
  }
})

const timelineSteps = computed(() => {
  const m = props.service.metadata
  const arrivedAt   = m && m.arrived_at    > 0 ? m.arrived_at    : null
  const startTripAt = m && m.start_trip_at > 0 ? m.start_trip_at : null
  const endTripAt   = m && m.end_trip_at   > 0 ? m.end_trip_at   : null
  return [
    { key: 'created',   label: t('services.fields.hour'),           at: props.service.created_at, active: props.service.created_at > 0, canceledOverride: false },
    { key: 'arrived',   label: t('services.fields.arrived_at'),     at: arrivedAt,                active: arrivedAt !== null,           canceledOverride: false },
    { key: 'tripStart', label: t('services.fields.trip_started_at'), at: startTripAt,             active: startTripAt !== null,         canceledOverride: false },
    { key: 'tripEnd',   label: t('services.fields.trip_ended_at'),  at: endTripAt,                active: endTripAt !== null,           canceledOverride: props.service.status === Service.STATUS_CANCELED },
  ]
})

const timelineDurations = computed(() => {
  const steps = timelineSteps.value
  const pairs = [
    { key: 'wait_for_arrival', a: steps[0], b: steps[1] },
    { key: 'wait_for_pickup',  a: steps[1], b: steps[2] },
    { key: 'trip_duration',    a: steps[2], b: steps[3] },
  ]
  return pairs.map(({ key, a, b }) => {
    const seconds =
      a.at !== null && a.at > 0 && b.at !== null && b.at > 0
        ? (b.at as number) - (a.at as number)
        : null
    return { key, seconds }
  })
})

const time = computed(() => {
  if (props.service.metadata?.start_trip_at === undefined || props.service.metadata?.end_trip_at === undefined) return '0s'
  return DateHelper.getTime(props.service.metadata?.start_trip_at, props.service.metadata?.end_trip_at) + 'min'
})

const fee = computed(() => {
  if (props.service.metadata?.trip_fee === undefined) return '0' + branchSelected?.currency_code
  return props.service.metadata?.trip_fee + branchSelected?.currency_code
})

const deducted = computed(() => {
  const value = props.service.deducted_value ?? props.service.metadata?.discount ?? 0
  return value + branchSelected?.currency_code
})

const multiplier = computed(() => {
  if (props.service.metadata?.trip_multiplier === undefined) return '1.0'
  return props.service.metadata?.trip_multiplier.toString()
})

const distance = computed(() => {
  if (props.service.metadata?.trip_distance === undefined) return '0.0'
  return (props.service.metadata?.trip_distance / 1000) + 'km'
})

const date = computed(() => {
  return DateHelper.unixToDate(props.service.created_at, 'MM-DD HH:mm:ss')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(['gorda-status-badge', `gorda-status-badge--${statusBadgeClass.value}`])
            }, _toDisplayString(_ctx.$t(`services.statuses.${__props.service.status}`)), 3),
            _createElementVNode("span", _hoisted_6, _toDisplayString(startLocName.value) + " → " + _toDisplayString(__props.service.end_loc?.name ?? _ctx.$t('common.placeholders.no_destination')), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(DateHelper).unixToDate(__props.service.created_at, 'YYYY-MM-DD HH:mm')), 1)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            type: "button",
            class: "gorda-icon-btn ms-2",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, [
            _createElementVNode("em", { class: "fa-solid fa-xmark" })
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Map, {
              route: __props.service.metadata?.route,
              places: location
            }, null, 8, ["route", "places"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h6", _hoisted_11, [
              _cache[1] || (_cache[1] = _createElementVNode("em", { class: "fa-solid fa-timeline me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.placeholders.timeline')), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelineSteps.value, (step, idx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: step.key
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                      'tl-dot',
                      step.active ? 'tl-dot--active' : 'tl-dot--inactive',
                      step.canceledOverride ? 'tl-dot--danger' : '',
                    ])
                    }, null, 2),
                    (idx < timelineSteps.value.length - 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([
                      'tl-segment',
                      timelineSteps.value[idx + 1].canceledOverride ? 'tl-segment--danger' : '',
                    ])
                        }, [
                          (timelineDurations.value[idx].seconds !== null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(DateHelper).aGo(timelineDurations.value[idx].seconds!)), 1))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelineSteps.value, (step, idx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: step.key + '-lbl'
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(step.canceledOverride ? _ctx.$t('services.statuses.canceled') : step.label), 1),
                      (step.active && !step.canceledOverride)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(DateHelper).unixToDate(step.at!, 'HH:mm:ss')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (idx < timelineSteps.value.length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h6", _hoisted_23, [
                  _cache[2] || (_cache[2] = _createElementVNode("em", { class: "fa-solid fa-circle-info me-2 service-info-card__icon--info" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.placeholders.service_info')), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, [
                    _createElementVNode("em", {
                      class: _normalizeClass(['fa-solid', originIcon.value, 'me-1', origin.value.kind === 'test' ? 'text-warning' : origin.value.kind === 'driver' ? 'text-primary' : ''])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('services.fields.origin')), 1)
                  ]),
                  _createElementVNode("span", _hoisted_26, [
                    _createTextVNode(_toDisplayString(origin.value.label), 1),
                    (origin.value.sublabel)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" · " + _toDisplayString(origin.value.sublabel), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (__props.service.directed_to)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('services.labels.target_driver')), 1),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(targetDriverName.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('services.fields.start_address')), 1),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(startLocName.value), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('services.fields.end_address')), 1),
                  _createElementVNode("span", _hoisted_35, _toDisplayString(__props.service.end_loc?.name ?? 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('services.fields.hour')), 1),
                  _createElementVNode("span", _hoisted_38, _toDisplayString(date.value), 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('common.fields.status')), 1),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t(`services.statuses.${ __props.service.status }`)), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('common.fields.name')), 1),
                  _createElementVNode("span", _hoisted_44, [
                    _createTextVNode(_toDisplayString(__props.service.name), 1),
                    _createVNode(ClientCompletedBadge, {
                      count: __props.service.client_completed_services_count
                    }, null, 8, ["count"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('common.fields.phone')), 1),
                  _createElementVNode("span", _hoisted_47, _toDisplayString(__props.service.phone), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('services.fields.comment')), 1),
                  _createElementVNode("span", _hoisted_50, _toDisplayString(__props.service.comment ?? 'N/A'), 1)
                ]),
                (__props.service.created_by !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('common.fields.created_by')), 1),
                      _createElementVNode("span", _hoisted_53, _toDisplayString(createdBy.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                (__props.service.terminated_by !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('common.fields.terminated_by')), 1),
                      _createElementVNode("span", _hoisted_56, _toDisplayString(terminatedBy.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                (__props.service.status === 'canceled')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _createElementVNode("h6", _hoisted_58, [
                        _cache[3] || (_cache[3] = _createElementVNode("em", { class: "fa-solid fa-ban me-2 text-danger" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.placeholders.canceled_by_section')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('common.fields.canceled_by')), 1),
                        _createElementVNode("span", _hoisted_61, _toDisplayString(canceledBy.value), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              (__props.service.driver)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("h6", _hoisted_64, [
                      _cache[4] || (_cache[4] = _createElementVNode("em", { class: "fa-solid fa-route me-2 service-info-card__icon--route" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('common.placeholders.route_info')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$t('services.fields.driver_name')), 1),
                      _createElementVNode("span", _hoisted_67, _toDisplayString(__props.service.driver.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t('drivers.fields.plate')), 1),
                      _createElementVNode("span", _hoisted_70, _toDisplayString(_unref(ServiceHelper).vehiclePlate(__props.service)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('services.fields.time')), 1),
                      _createElementVNode("span", _hoisted_73, _toDisplayString(time.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.$t('services.fields.distance')), 1),
                      _createElementVNode("span", _hoisted_76, _toDisplayString(distance.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('services.fields.fee')), 1),
                      _createElementVNode("span", _hoisted_79, _toDisplayString(fee.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t('services.fields.deducted')), 1),
                      _createElementVNode("span", _hoisted_82, _toDisplayString(deducted.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$t('services.fields.fee_multiplier')), 1),
                      _createElementVNode("span", _hoisted_85, _toDisplayString(multiplier.value), 1)
                    ]),
                    (__props.service.assigned_by !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                          _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.$t('common.fields.assigned_by')), 1),
                          _createElementVNode("span", _hoisted_88, _toDisplayString(assignedBy.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("button", _hoisted_90, _toDisplayString(_ctx.$t('common.actions.close')), 1)
        ])
      ])
    ])
  ]))
}
}

})